const PHONE_REGEX = /^[0-9.\-\/\| \+\(\)\[\]]{5,32}$/i;

/**
 * Simple Phone validator
 * @constructor
 */
class PhoneValidator {
  /**
   * @param {String}phone
   * @returns {Boolean}
   */
  static validate(phone) {
    return PHONE_REGEX.test(phone);
  }
}

export default PhoneValidator;
